import globalStore from '$$globalStore';

export default function (instance, ganttData) {
  instance.ganttDataApi.getCopiedTask = () => globalStore.getters['copyPaste/copiedTask'];
  instance.ganttDataApi.getCopyPastError = () => globalStore.getters['copyPaste/copyPastError'];
  instance.ganttDataApi.getSpecialPasteIconId = () => globalStore.getters['copyPaste/specialPasteIconId'];
  instance.ganttDataApi.hasCopiedTask = () => globalStore.getters['copyPaste/hasCopiedTask'];

  instance.ganttDataApi.copyTask = taskId => globalStore.dispatch('copyPaste/copy', +taskId);
  instance.ganttDataApi.pasteTask = options => globalStore.dispatch('copyPaste/paste', options);
  instance.ganttDataApi.setCopyPasteError = options => globalStore.dispatch('copyPaste/setCopyPasteError', options);

  instance.ganttDataApi.toggleCopySettingsPopup = flag => globalStore.commit('copyPaste/toggleCopySettingsPopup', flag);
  instance.ganttDataApi.setCopyPasteProjectId = projectId => globalStore.commit('copyPaste/setCurrentProjectId', projectId);
}
